import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenInventoryPageBreadcrumbs } from '@/pages/Inventory/config';
import { NavigateFunction } from 'react-router-dom';

export const officesPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenInventoryPageBreadcrumbs(navigate),
  { label: 'Ubicaciones', onClick: () => navigate('/inventory/geography') },
];

export const childrenOfficesPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenInventoryPageBreadcrumbs(navigate),
  { label: 'Ubicaciones', onClick: () => navigate('/inventory/geography') },
];

export const createOfficeBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenOfficesPageBreadcrumbs(navigate),
  {
    label: 'Oficinas',
    onClick: () => navigate('/inventory/geography/offices'),
  },
];

export const editOfficeBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenOfficesPageBreadcrumbs(navigate),
  {
    label: 'Oficinas',
    onClick: () => navigate('/inventory/geography/offices'),
  },
];
